<div class="modal-header">
  <h4 class="modal-title text-center w-100" *ngIf="!response">Write to us</h4>
  <h4 class="modal-title text-center w-100" *ngIf="response">
    <span *ngIf="response && response.is_error == 0">Message sent successfully</span>
    <span *ngIf="response && response.is_error == 1">Something went wrong</span>
  </h4>
  <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body px-sm-5 pb-4">
  <form #writeToUsForm="ngForm" (ngSubmit)="writeToUs(writeToUsForm)" *ngIf="!response || (response && response.is_error == 1)">
    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <label for="">Name<span class="text-danger">*</span></label>
          <input type="text" class="form-control" required name="name" #name="ngModel"
            [ngClass]="{'has-error':name.invalid && (name.touched || writeToUsForm.submitted)}"
            [ngModel]="planInfo.patient_name || payment_process_data.name" (ngModelChange)="planInfo.patient_name || (payment_process_data.name = $event)">
        </div>
      </div>
      <div class="col-12">
        <div class="form-group">
          <label for="">Email Address<span class="text-danger">*</span></label>
          <input type="text" [ngClass]="{'has-error':email.invalid && (email.touched || writeToUsForm.submitted)}"
            class="form-control" required name="email" #email="ngModel" [ngModel]="planInfo.patient_email || payment_process_data.patient_email" (ngModelChange)="planInfo.patient_email || (payment_process_data.patient_email = $event)">
        </div>
      </div>

      <div class="col-12">
        <div class="form-group">
          <label for="">Phone Number<span class="text-danger">*</span></label>
          <input required type="text" class="form-control" #phone="ngModel" name="phone"
            [ngModel]="planInfo.patient_mobile || payment_process_data.patient_mobile" (ngModelChange)="planInfo.patient_mobile || (payment_process_data.patient_mobile = $event)" maxlength=15 minlength=10 appNumberOnly
            [ngClass]="{'has-error':phone.invalid && (phone.touched || writeToUsForm.submitted)}"> <!-- [textMask]="{mask: mask,guide:false}" -->
        </div>
      </div>

      <div class="col-12">
        <div class="form-group">
          <label for="">Please describe your needs<span class="text-danger">*</span></label>
          <textarea [ngClass]="{'has-error':desc.invalid && (desc.touched || writeToUsForm.submitted)}"
            class="form-control" required [(ngModel)]="messageDesc" #desc="ngModel" name="desc" rows="4"></textarea>
        </div>
      </div>

      <div class="col-12">
        <p class="text-danger mb-3 small" *ngIf="writeToUsForm.invalid && writeToUsForm.submitted">
          Please fill all the required fields.
        </p>
      </div>

      <div class="col-6 text-center">
        <button type="button" class="btn btn-secondary py-2 px-4 rounded-pill" (click)="modalRef.hide()">
          Cancel
        </button>
      </div>

      <div class="col-6 text-center">
        <button class="btn btn-primary py-2 px-4 rounded-pill">
          Submit
        </button>
      </div>

    </div>
  </form>

  <div class="px-sm-5 text-center" *ngIf="response">
    <img src="assets/png/conversation.png" width="120px" class="mb-3" alt="">
    <p class="mb-4 h5">Your message has been sent successfully. Our representative will be in touch with you shortly.</p>
    <button class="btn btn-primary py-2 px-4 rounded-pill" (click)="response='';modalRef.hide()">
      Close
    </button>
  </div>

</div>